import * as React from 'react'

function SvgFlipHorizontal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.976 28a2 2 0 01-1.902-2.617L9.098 3.738C9.801 1.571 13 2.078 13 4.355V26a2 2 0 01-2 2H3.976zm20.669-3L20 10.681V25h4.645zm3.278.383A2 2 0 0126.02 28H19a2 2 0 01-2-2V4.357c0-2.278 3.2-2.784 3.903-.617l7.02 21.643z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgFlipHorizontal
